import 'trix/dist/trix.css'
import Trix from 'trix'
import sha1 from 'js-sha1'

(function() {
  var createStorageSignature, host, uploadAttachment;

  Trix.config.attachments.preview.caption = {
    name: false,
    size: false
  };

  document.addEventListener("trix-attachment-add", function(event) {
    var attachment;
    attachment = event.attachment;
    if (attachment.file) {
      return uploadAttachment(attachment);
    }
  });

  host = "/photo_uploads";

  uploadAttachment = function(attachment) {
    var file, form, key, xhr;
    var time = Date.now();
    file = attachment.file;
    form = new FormData;
    form.append("file", file);
    xhr = new XMLHttpRequest;
    xhr.open("POST", host, true);
    var csrfToken = document.querySelector('meta[name="csrf-token"]');
    if (csrfToken) {
      xhr.setRequestHeader("X-CSRF-Token", csrfToken.content);
    }
    xhr.upload.onprogress = function(event) {
      var progress;
      progress = event.loaded / event.total * 100;
      return attachment.setUploadProgress(progress);
    };
    xhr.onload = function() {
      var url;
      if (xhr.status === 200) {
        url = JSON.parse(xhr.response).url
        return attachment.setAttributes({
          url: url,
          href: url
        });
      }
    };
    return xhr.send(form);
  };

}).call(this);
